var map = {
	"./Cart.vue": "b3b1",
	"./CategoryCarousel.vue": "e5c3",
	"./HomeLayout.vue": "eb00",
	"./HorganiceCidReader.vue": "1cf2",
	"./HorganiceCidReaderDetail.vue": "ef81",
	"./HorganicePurchaseProduct.vue": "bf5a",
	"./ImagesCarousel.vue": "2b8c",
	"./ImagesCarousel2.vue": "ec93",
	"./MenuBar.vue": "c247",
	"./ModalLogin.vue": "1b13",
	"./NavBar.vue": "d000",
	"./ProductCarousel.vue": "8fea",
	"./ProductTypeMenu.vue": "b9ab",
	"./PurchaseModal.vue": "5f88",
	"./PurchaseStepBar.vue": "ba00",
	"./index.js": "2af9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8012";